/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { AcqOperator } from '../../interfaces/platform/AcqOperator';
import Filter from '../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { platformResellerConstants } from '../platformreseller/actions';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { AcqOperatorsCollectionInterface } from '../../interfaces/collections/AcqOperatorsCollectionInterface';
import Order from '../../interfaces/forms/Order';

const _ = require('underscore');

export type AcqOperatorLoaderType = {
    callback: () => void;
};

export class AcqOperatorLoader {
    private itemLoaders: ItemLoaders;

    private acqOperators: Array<AcqOperator>;

    private filters: Array<Filter> = [
        { name: 'pagination', value: false },
        { name: 'isMobile', value: true },
    ];

    private orders: Array<Order> = [{ name: 'mainname', value: 'asc' }];

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.acqOperators = [];
    }

    getOperatorNameByRpt = (operatorRpt: string | null, isMobile: boolean): string | null => {
        if (operatorRpt) {
            const acq = _.find(this.acqOperators, (obj: AcqOperator) => {
                return obj.isMobile === isMobile && obj.rpt === operatorRpt;
            });
            if (acq) {
                return acq.mainname;
            }
        }
        return null;
    };

    getAcqOperators = (): Array<AcqOperator> => {
        return this.acqOperators;
    };

    setAcqOperators = (acqOperators: Array<AcqOperator>): void => {
        this.acqOperators = acqOperators;
    };

    loadAcqOperators = (params: AcqOperatorLoaderType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/acq_operators')),
            platformResellerConstants.PLATFORM_RESELLER_LIST,
            this.filters,
            this.orders,
            (data: AcqOperatorsCollectionInterface): void => {
                const items = new Array<HeaderCheckBoxSelectListElement>();
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: AcqOperator) => {
                        this.acqOperators.push(item);
                    });
                    params.callback();
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getAcqOperatorsHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        const items = new Array<HeaderCheckBoxSelectListElement>();
        this.acqOperators.map((item: AcqOperator) => {
            if (item.rpt && item.mainname) {
                items.push({ name: item.mainname, value: item.id });
            }
        });
        return items;
    };

    getAcqOperatorById = (acqOperatorId: number): AcqOperator | null => {
        return _.find(this.acqOperators, (item: AcqOperator) => {
            return item.id === acqOperatorId;
        });
    };

    updateFilterRptSearch = (filters: Array<Filter>, type?: string): Array<Filter> => {
        const newValue: Array<string> = [];
        if (!type) {
            type = 'recipient';
        }
        filters.map((item: Filter) => {
            if (item.name === type) {
                if (Array.isArray(item.value)) {
                    for (let i = 0; i < item.value.length; i++) {
                        const reseller = this.getAcqOperatorById(parseInt(item.value[i].toString()));
                        if (reseller && reseller.rpt) {
                            newValue.push(reseller.rpt);
                        }
                    }
                }
                item.value = newValue;
            }
        });
        return filters;
    };
}
